// =============================================
// SERVICE: API de Configurações de Conferência
// =============================================

import { buildApiUrl, getDefaultHeaders } from './config';
import { getConferenteToken, handleConferenteSessionExpired } from './conferenteAuth';

export interface ConfiguracaoConferencia {
  id: number;
  empresa_id: number;
  exibir_doca: boolean;
  modo_carregamento: 'palete_individual' | 'lista_paletes';
  modo_pre_carregamento: 'palete_individual' | 'lista_paletes';
  modo_descarregamento: 'bipar_palete' | 'auto_detectar';
  exibir_area_descarregamento: boolean;
  habilitar_camera_scanner: boolean;
  acao_paletes_pendentes: 'nenhuma' | 'transferir' | 'excluir' | 'ocorrencia';
  criado_em: string;
  atualizado_em: string;
}

export async function buscarConfiguracoesConferencia(): Promise<{ success: boolean; configuracao: ConfiguracaoConferencia }> {
  const response = await fetch(buildApiUrl('/configuracoes-conferencia'), {
    headers: getDefaultHeaders()
  });
  if (response.status === 401 && getConferenteToken()) {
    handleConferenteSessionExpired();
    return new Promise(() => {});
  }
  if (!response.ok) throw new Error('Erro ao buscar configurações de conferência');
  return response.json();
}

export async function atualizarConfiguracoesConferencia(data: Partial<ConfiguracaoConferencia>): Promise<{ success: boolean; configuracao: ConfiguracaoConferencia; message: string }> {
  const response = await fetch(buildApiUrl('/configuracoes-conferencia'), {
    method: 'PUT',
    headers: getDefaultHeaders(),
    body: JSON.stringify(data)
  });
  if (response.status === 401 && getConferenteToken()) {
    handleConferenteSessionExpired();
    return new Promise(() => {});
  }
  if (!response.ok) throw new Error('Erro ao atualizar configurações de conferência');
  return response.json();
}
